import { render, staticRenderFns } from "./BatchModifyTitle.vue?vue&type=template&id=20b4a8d2&scoped=true"
import script from "./BatchModifyTitle.vue?vue&type=script&lang=js"
export * from "./BatchModifyTitle.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyTitle.vue?vue&type=style&index=0&id=20b4a8d2&prod&scoped=true&lang=css"
import style1 from "./BatchModifyTitle.vue?vue&type=style&index=1&id=20b4a8d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4a8d2",
  null
  
)

export default component.exports